import React, {
  useEffect,
} from 'react';
import clsx from 'clsx';
import Input from 'pages/Dashboard/components/Input';
import {
  getOrgNow,
} from 'utils/dayjs';
import {
  formatSignatureTimestamp,
} from 'utils/date';
import {
  FieldComponentProps,
} from 'views/EMR/components/FillableForm/types';

export default function SignatureTimestampField({
  field,
  value,
  onChange,
}: FieldComponentProps) {
  useEffect(() => {
    onChange({ ...(value ?? {}), value: formatSignatureTimestamp(getOrgNow()) });
    // Preview only; authoritative value is set server-side at PDF generation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Input
      key={field.id}
      id={field.id ?? undefined}
      value={typeof value?.value === 'string' ? value.value : ''}
      disabled
      className={clsx('w-full bg-[#e9edf4]')}
    />
  );
}
